import { useState } from "react";
import AdminBlogForm from "../pages/AdminBlogForm";
import AdminBlogList from "../pages/AdminBlogList";

const AdminPanel = () => {
  const [active, setActive] = useState("blogs");
  const [editBlog, setEditBlog] = useState(null);

  return (
    <div className="flex min-h-screen bg-gray-100 mt-[10%]">

      {/* Sidebar */}
      <div className="w-64 bg-[#0f172a] text-white p-5">
        <h2 className="text-2xl font-bold mb-6">Admin Panel</h2>

        <ul className="space-y-3">
          <li
            onClick={() => setActive("blogs")}
            className="cursor-pointer hover:text-yellow-400"
          >
            📄 Blogs
          </li>

          <li
            onClick={() => {
              setActive("add");
              setEditBlog(null);
            }}
            className="cursor-pointer hover:text-yellow-400"
          >
            ➕ Add Blog
          </li>
        </ul>
      </div>

      {/* Main */}
      <div className="flex-1 p-6">

        {active === "blogs" ? (
          <AdminBlogList
            setActive={setActive}
            setEditBlog={setEditBlog}
          />
        ) : (
          <AdminBlogForm
            setActive={setActive}
            editBlog={editBlog}
            setEditBlog={setEditBlog}
          />
        )}

      </div>
    </div>
  );
};

export default AdminPanel;